import { Component, OnInit } from '@angular/core';
import { VendorService } from '../../services/vendor.service';


@Component({
  selector: 'app-admin-vendors',
  templateUrl: './admin-vendors.component.html'
})
export class AdminVendorsComponent implements OnInit {
  vendors: any[] = [];
  constructor(private svc: VendorService) {
  }
  ngOnInit(): void {
    this.load();
  }
  load() {
    this.svc.getAllVendors().subscribe(v => this.vendors = v || []);
  }
  approve(id: number) {
    this.svc.approveVendor(id).subscribe(() => this.load());
  }
  reject(id: number) {
    this.svc.rejectVendor(id).subscribe(() => this.load());
  }
}
